import React from 'react';
import GeneralList from './GeneralList';
import { staffConfig } from './Config';

export default function StaffList() {
  return (
    <GeneralList
      title={staffConfig.title}
      addLabel={staffConfig.addLabel}
      icon={staffConfig.icon}
      fetchUrl={staffConfig.fetchUrl}
      submitUrl={staffConfig.submitUrl}
      createDataFunction={staffConfig.createDataFunction}
      rowHeaders={staffConfig.rowHeaders}
      editFields={staffConfig.fields}
      displayFields={staffConfig.displayFields}
      detailFields={staffConfig.detailFields}
    />
  );
}

